import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_DETAIL_SERVICE_TAG } from "@/features/LendingProgram/utils/lendingProgramServiceTags";
import { getQueryParams } from "@/utils/httpRequest";

const getLendingProgramDetailsEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    getLendingProgramDetails: builder.query({
      query: ({ lendingProgramId, parameterType, ...params }) =>
        `lending-programs/${lendingProgramId}/types/${parameterType}/parameters?${getQueryParams(params)}`,
      providesTags: (result, resultType, { parameterType }) => [
        { type: LENDING_PROGRAM_DETAIL_SERVICE_TAG, id: parameterType },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLendingProgramDetailsQuery } = getLendingProgramDetailsEndpoint;

